import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE } from './constants';
import Backend from './utils/Backend';

const RESOURCE_NAME = 'ClientHub';

const initConfig = {
    fallbackLng: DEFAULT_LANGUAGE,
    lng: DEFAULT_LANGUAGE,
    initImmediate: false,
    keySeparator: '_',
    react: {
        useSuspense: true,
    },
    backend: {
        resourceName: RESOURCE_NAME,
    },
    debug: false,
    interpolation: {
        escapeValue: false, // disabled as react escapes values by default
        defaultVariables: {
            // number formatting
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            currencyDisplay: 'code',
        },
    },
};

i18n
    // load translation using /resourcesets/{name}/?language={language}
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init(initConfig);

export default i18n;
